
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student-corner/iyengarpublications",
      function () {
        return require("private-next-pages/student-corner/iyengarpublications.js");
      }
    ]);
  